module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-reviews"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('router-link', {
    staticClass: "button centered",
    attrs: {
      "to": {
        name: 'BrandAchievementCreator'
      }
    }
  }, [_vm._v("Добавить достижение")])], 1), _vm._v(" "), _c('draggable', {
    staticClass: "columns is-multiline mt-10 reviews-columns",
    model: {
      value: (_vm.brandAchievementsObject),
      callback: function($$v) {
        _vm.brandAchievementsObject = $$v
      },
      expression: "brandAchievementsObject"
    }
  }, _vm._l((_vm.brandAchievementsObject), function(achievement) {
    return _c('BrandAchievementItem', {
      key: achievement.id,
      staticClass: "column is-half",
      attrs: {
        "achievement": achievement
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07d4d42a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrandAchievements.vue
// module id = 889
// module chunks = 0